import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ViewTableIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M0 15C0 15.5523 0.447715 16 1 16C1.55228 16 2 15.5523 2 15C2 14.4477 1.55228 14 1 14C0.447715 14 0 14.4477 0 15ZM0 8C0 8.55229 0.447715 9 1 9C1.55228 9 2 8.55229 2 8C2 7.44772 1.55228 7 1 7C0.447715 7 0 7.44772 0 8ZM1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0Z"
        fill="currentColor"
      />
      <path
        d="M4 15C4 15.5523 4.44772 16 5 16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H5C4.44772 14 4 14.4477 4 15ZM4 8C4 8.55229 4.44772 9 5 9H19C19.5523 9 20 8.55229 20 8C20 7.44772 19.5523 7 19 7H5C4.44772 7 4 7.44772 4 8ZM5 0C4.44772 0 4 0.447715 4 1C4 1.55228 4.44772 2 5 2H19C19.5523 2 20 1.55228 20 1C20 0.447715 19.5523 0 19 0H5Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(ViewTableIcon);
